import React from "react";
import { MISION, VISION, VALORES } from "../data/content";

export default function VisionMision() {
  return (
    <section id="brujula" className="band cream-soft" data-screen-label="03 Vision Mision">
      <div className="band-bg" />
      <div className="scatter" />
      <div className="tear-top tear-sage-top" />
      <div className="tear-bottom tear-coral-bottom" />

      <div className="wrap">
        <div className="sec-head">
          <h2 className="sec-title">Visión &amp; Misión</h2>
        </div>

        <div className="vm-grid">
          <div className="codex tilt-l">
            <div className="crest">★</div>
            <h3>{VISION.title}</h3>
            <p>{VISION.text}</p>
          </div>

          <div className="codex tilt-r green">
            <div className="crest">✿</div>
            <h3>{MISION.title}</h3>
            <p>
              En <b>Loremi Grand Party Hall</b> creamos experiencias inolvidables para las
              familias, ofreciendo eventos llenos de amor, seguridad y calidad. Nuestro compromiso
              es brindar un ambiente cálido y confiable, donde cada celebración se viva como en
              casa, acompañada de alimentos deliciosos, atención cercana y momentos que permanezcan
              en el corazón de nuestros clientes.
            </p>
          </div>
        </div>

        <div className="values-head">
          <h3 className="values-title">Nuestros Valores</h3>
        </div>

        <div className="values-grid">
          {VALORES.map((v) => (
            <div className="value" key={v.title}>
              <span className="v-ico">{v.ico}</span>
              <h4>{v.title}</h4>
              <p>{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
